<template>
  <div ref="content" class="content">
    <div class="content-wrapper">
      <div class="account-section" v-if="checkout.canShowAccountInfo()">
        <p :style="themeColor" class="sub-heading">Account</p>
        <div class="custom-fields account-section">

          <div class="clearfix double-address-fields" v-if="nameFields.length == 2">
            <text-field :customclass="'left'" :config="nameFields[0]" v-model="checkout.data[nameFields[0].name]"> </text-field>
            <text-field :customclass="'right'" :config="nameFields[1]" v-model="checkout.data[nameFields[1].name]"> </text-field>
          </div>

          <text-field :config="nameFields[0]" v-model="checkout.data[nameFields[0].name]" v-if="nameFields.length == 1">
          </text-field>

          <template v-for="field in accountFieldsWithoutName">
            <text-field :config="field" v-model="checkout.data[field.name]" v-if="field.type === 'text'"> </text-field>
            <select-box :config="field" v-model="checkout.data[field.name]" v-if="field.type === 'select'"> </select-box>
          </template>
        </div>
      </div>

      <billing-and-shipping :checkout="checkout" v-if="checkout.canShowAddress()"></billing-and-shipping>

      <payment-details :checkout="checkout" v-if="checkout.canShowCardInfo()"></payment-details>

      <!-- TODO validate and enable -->
      <div class="footer-section">
        <button :style="backgroundColor" @click="next()">Pay {{checkout.finalAmount()}} and Subscribe</button>

        <p class="terms-of-service">By clicking the button you agree to out <span>Terms of Service</span></p>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import TextField from "./TextField.vue";
  import SelectField from "./SelectField.vue";
  import BillingAndShippingInfo from "./BillingAndShippingInfo.vue";
  import PaymentDetails from "./PaymentDetails.vue";

  export default {
    name: 'checkout-info',
    props: ['checkout'],
    components: {
      'text-field' : TextField,
      'select-box': SelectField,
      'billing-and-shipping': BillingAndShippingInfo,
      'payment-details': PaymentDetails
    },
    computed: {
      accountFieldsWithoutName() {
        return this.checkout.accountInfoFieldsForDisplay().filter(f => !["customer[first_name]", "customer[last_name]"].includes(f.name));
      },

      nameFields() {
        return this.checkout.accountInfoFieldsForDisplay().filter(f => ["customer[first_name]", "customer[last_name]"].includes(f.name));
      }
    },
    methods: {
      next() {
        var cardWrapper = document.querySelectorAll(".wrapper-position")[0];
        var container = document.querySelectorAll(".container")[0];
        container.classList.add("reverse-animation");
        setTimeout(function() {
          var cardWrapper = document.querySelectorAll(".wrapper-position")[0];
          var container = document.querySelectorAll(".container")[0];
          window.scroll(0,0);
          container.classList.add("thank-you-animation");
          document.querySelectorAll(".order-card")[0].classList.add("translateCard");
          container.classList.remove("expand");
          setTimeout(function() {
            this.checkout.currentStep = 2;
          }.bind(this), 700);
        }.bind(this), 700);
      }
    },
    mounted() {
      this.$refs.content.style.visibility = "visible";
    }
  }
</script>

<style scoped>
.content {
  visibility: hidden;
}

</style>


// WEBPACK FOOTER //
// CheckoutInfo.vue?bd5f6a88